module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"PENDING PAYMENTS"},"et":{"title":"PENDING PAYMENTS"},"ru":{"title":"PENDING PAYMENTS"}}')
  delete Component.options._Ctor
}
